/**
 * @generated SignedSource<<ce83476b13ca237f83762141072119d1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
import { FragmentRefs } from "relay-runtime";
export type agendaAppointmentDrawerData_appointment$data = {
  readonly appointmentAttachments: ReadonlyArray<{
    readonly attachmentType: DocumentType;
    readonly fileName: string;
    readonly id: string;
    readonly thumbnailUrl: string | null;
    readonly uploadDate: string;
    readonly uploadSource: FileUploadSource;
    readonly uploadStatus: FileUploadStatus | null;
    readonly url: string;
  }>;
  readonly fileUploadRequest: {
    readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
  } | null;
  readonly healthOverview: {
    readonly generalHealthInformation: {
      readonly " $fragmentSpreads": FragmentRefs<"GeneralHealthInformationFragment">;
    } | null;
    readonly vitalSign: {
      readonly " $fragmentSpreads": FragmentRefs<"VitalSignFragment">;
    } | null;
  } | null;
  readonly id: string;
  readonly questionnaireId: number | null;
  readonly reason: string;
  readonly status: AppointmentStatus;
  readonly telephoneLine: {
    readonly telephoneLineTranslations: ReadonlyArray<{
      readonly content: string;
      readonly language: Language;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment" | "appointmentDrawerCardHeaderReviewStatus_appointment" | "appointmentDrawerCardHeader_appointment" | "appointmentDrawerQuestionnaire_appointment" | "appointmentDrawerStatusIndicator_appointment" | "missedCallAgendaAppointmentDrawerDataFragment">;
  readonly " $fragmentType": "agendaAppointmentDrawerData_appointment";
};
export type agendaAppointmentDrawerData_appointment$key = {
  readonly " $data"?: agendaAppointmentDrawerData_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"agendaAppointmentDrawerData_appointment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "agendaAppointmentDrawerData_appointment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionnaireId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_TelephoneLine",
      "kind": "LinkedField",
      "name": "telephoneLine",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_TelephoneLineTranslation",
          "kind": "LinkedField",
          "name": "telephoneLineTranslations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentAttachment",
      "kind": "LinkedField",
      "name": "appointmentAttachments",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attachmentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadSource",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FileUploadRequest",
      "kind": "LinkedField",
      "name": "fileUploadRequest",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FileUploadRequestFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerCardHeader_appointment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HealthOverview",
      "kind": "LinkedField",
      "name": "healthOverview",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VitalSign",
          "kind": "LinkedField",
          "name": "vitalSign",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VitalSignFragment"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GeneralHealthInformation",
          "kind": "LinkedField",
          "name": "generalHealthInformation",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GeneralHealthInformationFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestedMedicationsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerCardHeaderReviewStatus_appointment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerQuestionnaire_appointment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerStatusIndicator_appointment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "missedCallAgendaAppointmentDrawerDataFragment"
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};
})();

(node as any).hash = "3795fd22dcea3beb702476a47cda7a9d";

export default node;
